import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 课程分类列表
  classifylist(id) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/classify/list/'+id,
      method: 'get'
    })
  },
  // 课程列表
  classpage(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/page',
      method: 'get',
      params: arg
    })
  },
  // 学习任务列表
  classTask(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/task',
      method: 'get',
      params: params
    })
  },
  // 历史学习列表
  classHistory(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/history',
      method: 'get',
      params: params
    })
  },
  // 课程详情内容(课程信息+课程视频列表)
  classinfo(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/detail/',
      method: 'get',
      params: params
    })
  },
  // 人脸拍照识别
  facecheck(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/face/check',
      method: 'post',
      data: arg
    })
  },
  // 视频播放结束调用接口
  videoFinish(data) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/item/finish',
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/courselearn/index.js